import { LngLat } from 'maplibre-gl';

export class BackendLocationModel {
  readonly id: number;
  readonly latitude: number;
  readonly longitude: number;
  readonly altitude?: number|null;
  readonly accuracy?: number|null;
  readonly speed?: number|null;
  readonly heading?: number|null;
  readonly flags: number;
  readonly gpsSource?: string|null;
  readonly hdop?: number|null;

  static updateFromLngLat(location: BackendLocationModel, lngLat: LngLat): BackendLocationModel {
    return {
      id: location.id,
      longitude: lngLat.lng,
      latitude: lngLat.lat,
      flags: location.flags,
    };
  }
}

export class BackendLocationModelWithTime extends BackendLocationModel {
  readonly time: Date;
}

export class TrackViewState {
  readonly snapshot: number;
  readonly tileTemplate: string;
  readonly headTemplate: string;
}
